import axios, { AxiosHeaderValue } from "axios";
import { useEffect, useState } from "react";
import beaconMasterResultType from "../model/BeaconMasterResultType";
import { Button, Col, Form, Row } from "react-bootstrap";
import Result from "../Components/BeaconMasterResultCommonDevice";
import Header from "../Components/Header";
import PageSelect from "../Components/PageSelect";
import Loading from "../Components/Loading";

const CommonDevice = () => {

    const [apiKey, setApikey] = useState<string>("");
    const [selectParam, setSelectParam] = useState<string>("")
    const [id, setId] = useState<string>("");
    const [per_page, setPer_Page] = useState<string>("");
    const [name, setName] = useState<string>("");
    const [local_name, setLocal_name] = useState<string>("");
    const [uuid, setUuid] = useState<string>("");
    const [major, setMajor] = useState<string>("");
    const [minor, setMinor] = useState<string>("");
    const [action_id, setAction_id] = useState<string>("");
    const [tx_power, setTx_power] = useState<string>("");
    const [battery_gt, setBattery_gt] = useState<string>("");
    const [battery_lt, setBattery_lt] = useState<string>("");
    const [module_id, setModule_id] = useState<string>("");
    const [manufacturer, setManufacturer] = useState<string>("");
    const [model, setModel] = useState<string>("");
    const [note, setNote] = useState<string>("");
    const [x, setX] = useState<string>("");
    const [y, setY] = useState<string>("");
    const [h, setH] = useState<string>("");
    const [enabled, setEnabled] = useState<string>("");
    const [created_gt, setCreated_gt] = useState<string>("");
    const [created_lt, setCreated_lt] = useState<string>("");
    const [updated_gt, setUpdated_gt] = useState<string>("");
    const [updated_lt, setUpdated_lt] = useState<string>("");
    const [sort, setSort] = useState<string>("");
    const [pageNo, setPageNo] = useState<number>(0);
    const [lastPageNo, setLastPageNo] = useState<number>(0);
    const [total, setTotal] = useState<number>(-1);
    const [result, setResult] = useState<beaconMasterResultType[]>([]);
    const results: beaconMasterResultType[] = [];
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [bundle_ids,setBUndle_ids] = useState<string[]>([""]);
    let maxindex: number = 0
    let maxfrom: number = 0
    

    var apiUrl:string = "";

    const checkLocoEnv = () => {
      if (localStorage.getItem("locoEnv") === "prod") {
        apiUrl = "https://api.bc-loco.jp/api/beacons"
      } else {
        apiUrl = "http://stg.api.bc-loco.jp/api/beacons"
      }
    }
    
    const getBeacon = async(e: any, pageNo: number) => {
        e.preventDefault();
        saveParams();
        saveApikey();
        checkLocoEnv();
        await axios.get(apiUrl,
        {
          headers: {
              "Authorization": apiKey,
              "Content-Type": "application/json"
          },
          params: {
              ...(id ? {id: id} : {}),
              ...(pageNo ? {page: pageNo} : {}),
              ...({per_page: 1000}),
              ...(name ? {name: name} : {}),
              ...(local_name ? {local_name: local_name} : {}),
              ...(uuid ? {uuid: uuid} : {}),
              ...(major ? {major: major} : {}),
              ...(minor ? {minor: minor} : {}),
              ...(action_id ? {action_id: action_id} : {}),
              ...(tx_power ? {tx_power: tx_power} : {}),
              ...(battery_gt ? {battery_gt: battery_gt} : {}),
              ...(battery_lt ? {battery_lt: battery_lt} : {}),
              ...(module_id ? {module_id: module_id} : {}),
              ...(manufacturer ? {manufacturer: manufacturer} : {}),
              ...(model ? {model: model} : {}),
              ...(note ? {note: note} : {}),
              ...(x ? {x: x} : {}),
              ...(y ? {y: y} : {}),
              ...(h ? {h: h} : {}),
              ...(enabled ? {enabled: enabled} : {}),
              ...(created_gt ? {created_gt: created_gt.replace("T", " ")} : {}),
              ...(created_lt ? {created_lt: created_lt.replace("T", " ")} : {}),
              ...(updated_gt ? {updated_gt: updated_gt.replace("T", " ")} : {}),
              ...(updated_lt ? {updated_lt: updated_lt.replace("T", " ")} : {}),
              ...(sort ? {sort: sort} : {})
          }
        })
        .then(async res => {
          console.log(res);
          if(res.data.code === 400) {
            alert("条件設定に問題があります。" + JSON.stringify(res.data.payload))
            return
          } else if(res.data.code === 401) {
            alert("APIKeyが正しく入力されていません。" + JSON.stringify(res.data.message))
            return
          }
          const items = JSON.parse(JSON.stringify(res.data.payload))
          if (items.total > 100000) {
            alert("10万件を超えるデータは表示出来ません。 総件数:" + items.total + "\n日付範囲を調整して下さい。")
            return 
          }
          setTotal(items.total)
          setPageNo(items.current_page)
          setLastPageNo(items.last_page)
          
          items.data.forEach((value: beaconMasterResultType, index: number) => {
            results.push(value)
            results[index].no = items.from;
            items.from++;
            //maxindex = index
            //maxfrom = items.from;
          })
/*
          console.log("maxindex: " + maxindex)
          console.log("maxfrom: " + maxfrom)

          //暫定
          let zantei: beaconMasterResultType[] = []
          zantei.id = "89334804-e5e8-417f-9325-b0f564b60794"
          zantei.name = "LO_KYB_00001"
          zantei.local_name = "LO_KYB_00001"
          zantei.note = "大阪環状線　京橋駅改札"
          */



          setResult(results)
          
        })
        .catch(err => 
          alert("エラーが発生しました。" + err)
        )
    }

   

  const changeCreatedGt = (value: string) => {
    if (value.length >= 1 && value.length < 17) {
      value = value + ":00";
    }
    setCreated_gt(value);
  }

  const changeCreatedLt = (value: string) => {
    if (value.length >= 1 && value.length < 17) {
      value = value + ":00";
    }
    setCreated_lt(value);
  }

  const changeUpdateGt = (value: string) => {
    if (value.length >= 1 && value.length < 17) {
      value = value + ":00";
    }
    setUpdated_gt(value);
  }

  const changeUpdateLt = (value: string) => {
    if (value.length >= 1 && value.length < 17) {
      value = value + ":00";
    }
    setUpdated_lt(value);
  }

  const getNowDate = () => {
    let dt = new Date();
    let y = dt.getFullYear();
    let m = ("00" + (dt.getMonth()+1)).slice(-2);
    let d = ("00" + (dt.getDate())).slice(-2);
    let result = y  + m +  d;
    return result;
  }

  type beaconParamsType = {
    id?: string,
    perpage?: string,
    page?: number,
    name?: string,
    local_name?: string,
    uuid?: string,
    major?: string,
    minor?: string,
    action_id?: string,
    tx_power?: string,
    battery_gt?: string,
    battery_lt?: string,
    module_id?: string,
    manufacturer?: string,
    model?: string,
    note?: string,
    x?: string,
    y?: string,
    h?: string,
    enabled?: string,
    created_gt?: string,
    created_lt?: string,
    updated_gt?: string,
    updated_lt?: string,
    sort?: string,
    bundle_id?: string
  }

  const saveParams = () => {
    let params: beaconParamsType = {};
    params.id = id ? id : "";
    params.perpage = per_page ? per_page : "";
    params.name = name ? name : "";
    params.local_name = local_name ? local_name : "";
    params.uuid = uuid ? uuid : "";
    params.major = major ? major : "";
    params.minor = minor ? minor : "";
    params.action_id = action_id ? action_id : "";
    params.tx_power = tx_power ? tx_power : "";
    params.battery_gt = battery_gt ? battery_gt : "";
    params.battery_lt = battery_lt ? battery_lt : "";
    params.module_id = module_id ? module_id : "";
    params.manufacturer = manufacturer ? manufacturer : "";
    params.model = model ? model : "";
    params.note = note ? note : "";
    params.x = x ? x : "";
    params.y = y ? y : "";
    params.h = h ? h : "";
    params.enabled = enabled ? enabled : "";
    params.created_gt = created_gt ? created_gt : "";
    params.created_lt = created_lt ? created_lt : "";
    params.updated_gt = updated_gt ? updated_gt : "";
    params.updated_lt = updated_lt ? updated_lt : "";
    params.sort = sort ? sort : "";
    
    let json = JSON.stringify(params);
    console.log("params:" + json);
    localStorage.setItem("locoBeaconMasterParams", json)

  }
  const saveApikey = () => {
    localStorage.setItem("locoApikey", apiKey ? apiKey : "" );
  }

  const loadParams = () => {
    const paramsJson = localStorage.getItem("locoBeaconMasterParams")
    if (paramsJson != null) {
      const params:beaconParamsType = JSON.parse(paramsJson as string)
      setId(params.id ? params.id : "");
      setPer_Page(params.perpage ? params.perpage : "");
      setName(params.name ? params.name : "");
      setLocal_name(params.local_name ? params.local_name : "");
      setUuid(params.uuid ? params.uuid : "");
      setMajor(params.major ? params.major : "");
      setMinor(params.minor ? params.minor : "");
      setAction_id(params.action_id ? params.action_id : "");
      setTx_power(params.tx_power ? params.tx_power : "");
      setBattery_gt(params.battery_gt ? params.battery_gt : "");
      setBattery_lt(params.battery_lt ? params.battery_lt : "");
      setModule_id(params.module_id ? params.module_id : "");
      setManufacturer(params.manufacturer ? params.manufacturer : "");
      setModel(params.model ? params.model : "");
      setNote(params.note ? params.note : "");
      setX(params.x ? params.x : "");
      setY(params.y ? params.y : "");
      setH(params.h ? params.h : "");
      setEnabled(params.enabled ? params.enabled : "");
      setCreated_gt(params.created_gt ? params.created_gt : "");
      setCreated_lt(params.created_lt ? params.created_lt : "");
      setUpdated_gt(params.updated_gt ? params.updated_gt : "");
      setUpdated_lt(params.updated_lt ? params.updated_lt : "");
      setSort(params.sort ? params.sort : "");
      //setBundle_id(params.bundle_id ? params.bundle_id : "");
    }
  }

  const loadApikey = () => {
    const locoApikey = localStorage.getItem("locoApikey")
    if (locoApikey != null) {
      setApikey(locoApikey ? locoApikey : "");
    }
  }

  const selectApiKey = (value :string) => {
    setSelectParam(value)
    let values = value.split(",")
    setApikey(values[0])
    values.shift()
    setBUndle_ids(values)
    console.log("bundle_ids:" + bundle_ids)
  }

  const setSelectApikey = () => {
    const secretJson = localStorage.getItem("locoSecretArray")
    if (secretJson != null) {
      const secret = JSON.parse(secretJson as string)

      const selectApikey = document.getElementById("apikey") as HTMLSelectElement;
      const option1 = document.createElement("option");
      option1.value = "";
      option1.textContent = "APIKeyを選択して下さい";
      selectApikey?.appendChild(option1)
/*
      secret.forEach((element: { apikey: string; name: string | null; }) => {
          const option1 = document.createElement("option");
          option1.value = element.apikey;
          option1.textContent = element.name;
          selectApikey?.appendChild(option1)
      })
          */
      secret.forEach((element, idx) => {
        const option1 = document.createElement("option");
        option1.value = element.apikey +
        "," + element.bundle_ios + 
        "," + element.bundle_and +
        "," + element.bundle_gate;
        option1.textContent = element.name;
        selectApikey?.appendChild(option1)
      })
    }
  }


  useEffect(() => {
    const secretJson = localStorage.getItem("locoSecretArray")
    if (secretJson != null) {
      setSelectApikey()
    }
    loadParams();
    loadApikey();
      
  },[])

  return (
    <div>
    <Header current_page="CommonDevice"/>
    <div className="card">
      <Form className="font-weight-bold" onSubmit={(e) => getBeacon(e, 0)}>
        
        <Form.Group as={Row} className="mx-3">
          <Col xs={12} md={4}>
            <Form.Label>ApiKey</Form.Label>
            <Form.Control as="select" id="apikey" value={selectParam as string} placeholder="ApiKeyを入力" onChange={(e) => selectApiKey(e.target.value)} />
          </Col>
          <Col xs={12} md={4}>
            <Form.Label>Name</Form.Label>
            <Form.Control type="text" name="Name" value={name as string} className="w-27" placeholder="Nameを入力" onChange={(e) => setName(e.target.value)} />
          </Col>
          <Col xs={12} md={4}>
            <Form.Label>LocalName</Form.Label>
            <Form.Control type="text" name="LocalName" value={local_name as string} className="w-27" placeholder="LocalNameを入力" onChange={(e) => setLocal_name(e.target.value)} />
          </Col>
          
        </Form.Group>
        
        <Form.Group as={Row} className="mx-3">
          <Col xs={12} md={4}>
            <Form.Label>UUID</Form.Label>
            <Form.Control type="text" name="uuid" value={uuid as string} className="w-27" placeholder="UUIDを入力" onChange={(e) => setUuid(e.target.value)} />
          </Col>
          <Col xs={12} md={4}>
            <Form.Label>Major</Form.Label>
            <Form.Control type="text" name="major" value={major as string} className="w-27" placeholder="Majorの値を入力" onChange={(e) => setMajor(e.target.value)} />
          </Col>
          <Col xs={12} md={4}>
            <Form.Label>Minor</Form.Label>
            <Form.Control type="text" name="minor" value={minor as string} className="w-27" placeholder="Minorの値を入力" onChange={(e) => setMinor(e.target.value)} />
          </Col>
        </Form.Group>
        <Form.Group as={Row} className="mx-3">
          <Col xs={12} md={4}>
            <Form.Label>Sort（デフォルト: DESC（新着順））</Form.Label>     
            <Form.Control as="select" className="w-27" value={sort as string} onChange={e => setSort(e.target.value)} >
                <option value="">ASC（古い順）またはDESC（新着順）を指定</option>
                <option value="asc">ASC（古い順）</option>
                <option value="desc">DESC（新着順）</option>
            </Form.Control>
          </Col>
        </Form.Group>
        

        <div className="text-center">
          <Form.Group as={Button} type="submit" className="mt-3 mb-2">View BeaconMaster</Form.Group>
        </div>
      </Form>
    </div>
    {(() => {
      if (isLoading) {
        return (
          <div>
            <Loading/>
          </div>
        )
      }
    })()}

    {(() => {
    if (result.length > 0) {
        return  (
          <div>
            <p className="mx-4">TotalCount:{total}</p>
            <div className="d-flex justify-content-around">     
              <PageSelect pageNo={pageNo} lastPageNo={lastPageNo} getLog={getBeacon}></PageSelect>  
            </div>  
            
            <Result result={result} bundle_ids={bundle_ids} apikey={apiKey}></Result>
            
          </div>
        );
    } else {
        return (
          <div>
              {
                  total === 0 && <p className="mx-4">TotalCount:{total}</p> 
              }
          </div>
        );
    }
    
    })()}
    </div>
  )
}

export default CommonDevice